import { createSelector } from 'reselect'
import { entitySelector } from 'containers/Entity/selectors'
import cloneDeep from 'lodash/cloneDeep'
import _ from 'lodash'

const hierarchiesEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.project_hierarchy_views
    ? entities.project_hierarchy_views
    : {}
)

const hierarchiesSelector = createSelector(
  hierarchiesEntitySelector,
  (entity) => {
    if(Object.values(entity)[0]){
      return cloneDeep(Object.values(entity)[0])
    } else {
      return {}
    }
  }
)

const hierarchyTypeSourceSelector = createSelector(
  hierarchiesSelector,
  (hierarchy) => _.isEmpty(hierarchy) ? null : hierarchy.hierarchyType
)

const projectsSourceSelector = createSelector(
  hierarchiesSelector,
  (hierarchy) => {
    return (_.isEmpty(hierarchy.projects) ? [] : hierarchy.projects)
  }
)

const activeSelector = state => state.project.hierarchies.active
const hierarchySelector = state => state.project.hierarchies.hierarchy
const projectsSelector = state => state.project.hierarchies.projects
const searchSelector = state => state.project.hierarchies.search

export {
  hierarchyTypeSourceSelector,
  projectsSourceSelector,
  activeSelector,
  hierarchySelector,
  projectsSelector,
  searchSelector
}
